var exports = {
  "oB": "titleWrapper__dNNW4i",
  "cf": "withFilterSpacing__oVvwuY",
  "wx": "header__AHAsnE",
  "kz": "titleArea__4h4TuA",
  "gr": "titleIcon__bdxlNj",
  "I8": "statusIcon__-IOnRG",
  "DD": "title__L6ueMQ",
  "h_": "description__ioSGzv",
};

module.exports = exports;
